// HOWITWORKS - This object is basically the "state" of the application. This will store filter and sorting parameters, list content, what data to populate into different navs, etc. This does NOT store server data whatsoever! We'll be using Vuex and the store.js file for that later in the application, and it's pretty great. This will however store ID references to data in the store. For example, a selected item on a page will store only the ID on this object, and a list stored on this object will contain an array of IDs that reference the store. This ID will be passed into the Vuex state, which will return the full object. More on that later.



// This part is kind of weird, but because the navigation on desktop and mobile put the same data in different spots, some of them are defined on their own and then added to the different arrays where necessary. These arrays are then templated in their navigation components.

// CompanyNavOption is a weird one because it needs to store the "target" as the last page that was used. The "company" route alone doesn't exist, it's always "company/properties" for example. We need to store the 2nd half of the route, so when the user selects this tab, it returns them to the last Company page they came from. If there were nav pages for each of them individually, we wouldn't need this.

var companyNavOption = {
  route: 'company',
  target: 'properties',
  title: 'Company',
  icon: 'mdi-domain',
  permissions: ['property', 'ticketType', 'role']
};

var settingsNavOption = {
  title: 'Settings',
  icon: 'mdi-settings',
  route: 'settings'
};

var signoutNavOption = {
  title: 'Sign Out',
  icon: 'mdi-exit-to-app',
  action () {

    // Dialog.vue initializes itself on window so that we can create dialogs from anywhere
    Dialog.showDialog({
      title: 'Sign Out',
      body: 'Are you sure you want to sign out?',
      confirm: {
        action () {

          // AppData is a globally defined Vue instance that stores methods and properties important for the entire application to function. AppData is the first Vue instance created in main.js. AppData will take an instance of {app} (this file) and add computed properties, watchers, etc to automate a bunch of tasks in the app for us. It also gives us global access to the router, store, and more. There will be more HOWITWORKS comments where AppData is initialized.
          AppData.$router.replace({name: 'signout'});
          return Promise.resolve();
        },
        title: 'Sign Out'
      }
    })
  }
}

var navigation = {
  tickets: {
    route: 'tickets',   // Name of route to use (as defined in router)
    title: 'Tickets',   // Title to show on navigation
    icon: 'mdi-ticket', // Icon to use in Mobile Navigation
    permissions: ['ticket', 'ticketManager', 'ticketAdmin'] // User requires one of these permissions to see this option
  },
  people: {
    route: 'people',
    title: 'People',
    icon: 'mdi-account-multiple',
    target: 'joined',
    permissions: ['user']
  },
  units: {
    route: 'units',
    title: 'Units',
    icon: 'mdi-home',
    permissions: ['unit']
  },
  company: companyNavOption
};

var navigationMobile = {
  ...navigation,
  settings: settingsNavOption,
  signout: signoutNavOption
};

var companyNav = {
  properties: {
    title: 'Properties',
    route: 'properties',
    permissions: ['property']
  },
  ticketTags: {
    title: 'Ticket Tags',
    route: 'ticketTags',
    permissions: ['ticketType']    
  },
  roleTemplates: {
    title: 'Role Templates',
    route: 'roleTemplates',
    permissions: ['role']    
  }
};

// ACCOUNT NAVS

var accountNav = [
  {
    title: 'Changelog',
    icon: 'mdi-information-outline',
    action () {
      var query = {...AppData.$router.query};
      query.dialog = 'changelog';
      window.AppData.$router.replace({
        query: query
      });
    }
  },
  {
    title: 'Contact',
    icon: 'mdi-email',
    action () {
      var url = window.urls.support;
      if (window.cordova) url += '?fromApp=true';
      window.open(url, '_blank');
    }
  },
  {
    title: 'Feedback',
    icon: 'mdi-message-alert',
    action () {
      window.AppData.openFeedback(); // This needs to check the user permissions to determine which Feedback page to open, so we need to do this after the App has been initialized
    }
  }
];

var accountNavDesktop = [
  settingsNavOption,
  ...accountNav,
  signoutNavOption
];

var accountNavMobile = [
  ...accountNav
];


/* 
  HOWITWORKS

  This is where the main pages are defined.

  The purpose of these objects is to fill the page template with content, but even more awesome, store a reference to most of the items interacted with in the application which will two-way bind anywhere they are referenced. Later in the flow, this object will be initialized into a Vue instance called AppData. This means any time something is manipulated that is stored in this object, changes will be reflected via two-way binding. This also means we can add Vue features such as watch, computed, etc to our app.js contents (which we do later in main.js after importing this file). 
  
    filterComponent - Which component to use when this page is loaded into the PageTemplate component. vo-filter is the normal "Filter" section, which will populate itself with whatever is passed into it via the page.filter property defined below. It can accept "search" and "filters". 
    
    filtering: {

      search: {
        placeholder: defines just the placeholder
        value: Current value of search input, bound to the search input field using v-model.
      }

      filters: defines all the values necessary to create the query string passed in backend requests used for filtering data (?property=all&status=all). Adding and removing filters to the reference will update the front end template, meaning we can add things afterwards (like statuses, properties, etc) that are specific to the company. These properties are binded using v-model to the Filters component, so changes made to the filter directly change the value stored inside 'filters.filterProp.value'. By adding a watcher to the AppData component, we can react to changes made by the user (done when the AppData component is defined on main.js).

      {
        key: { // Key must match what the server expects as the query parameter for this filter (ie: GET api.vilio.co/properties/?property=all < key is "property")
          title: What to show in the filter
          value: current filter value
          options: [
            {
              title: String - What to show in the filter
              value: String - what value this filter should have, usually an ID
            }
          ],
          permissions: If this filter is permission based, what permission do they need to have to see it
        }
      }
    }

    sort: {
      these will populate into the ListHeader component, and just like filters, are watched via AppData.$watch so we can react to changes.

      options: {
        key: { // Should match the server query param
          title: String - What to show in the List Header
          value: (MUST BE -1 || 1) - What the current value is
        }
      },
      value: String - key // refernces a key from the "options" object. It will look at sort.options[sort.value].value to get the current value of that sort
      
      ie: if value is "number", it will look at sort.options['number'].value to see if its -1 or 1;
    }

    fab: { // Whether or not this page has a fab button.
      permissions: If this is permission based, what permissions the user must have to see this fab
      click: String name of the dialog to show, kebab-case but without the 'vo-' prefix (ie: 'ticket-create');
    }

    selected: stores a reference to the existing selected item as an ID reference to the $store

    listParams: Used in conjunction with ListParams. Stores some data for populating some list data (ie: Name will populate the List's empty state). This will be passed in when initializing the list, ie: page.list = new ListModel(page.listParams).

*/

var ticketsPage = {
  title: 'Tickets',
  permissions: ['ticket', 'ticketManager', 'ticketAdmin'],
  fab: {
    click: 'ticket-create'
  },
  filterComponent: {
    cmp: 'vo-filter'
  },
  filtering: {
    // search: {
    //   placeholder: 'Search Tickets',
    //   value: ''
    // },
    filters: {
      property: {
        title: 'Properties',
        value: '',
        options: []
      },
      status: {
        title: 'Statuses',
        value: 'unresolved',
        options: [
          {
            value: 'unresolved',
            title: 'Unresolved'
          }
        ]
      },
      type: {
        title: 'Ticket Tags',
        value: '',
        options: []
      }
    }
  },
  sort: {
    value: 'number',
    options: {
      number: {
        title: 'Ticket #',
        value: -1 
      },
      lastModified: {
        title: 'Activity',
        value: -1
      }
    }
  },
  ticketNotes: {
    listParams: {
      name: 'Ticket Notes',
      action: 'loadTicketNotes',
      requires: ['ticket', 'property'],
      params: {
        ticket: null
      }
    }
  },
  ticketChat: {
    listParams: {
      name: 'Ticket Chat',
      action: 'loadTicketChats',
      requires: ['ticket'],
      params: {
        ticket: null
      },
      filters: {
        sort: {
          value: 'created',
          options: {
            created: {
              title: 'Created',
              value: -1
            }
          }
        }
      },
      flip: true
    }
  },
  listParams: {
    name: 'Tickets',
    action: 'loadTickets', // This is in the Store (this.$store.dispatch(loadTickets)
    params: {
      company: ''
    },
    requires: ['company']    
  },
  selected: false
};

var peoplePage = {
  title: 'People',
  permissions: ['user'],
  fab: {
    click: 'invite-create',
    permissions: ['invite']  
  },
  filterComponent: {
    cmp: 'vo-filter'
  },
  filtering: {
    search: {
      placeholder: 'Search People',
      value: ''
    },
    filters: {
      property: {
        title: 'Property',
        value: '',
        options: []
      },
      role: {
        title: 'Roles',
        value: '',
        options: [],
        permissions: ['role']
      },
      people: {
        title: 'People',
        value: 'joined',
        onchange: 'reroute',
        permissions: ['invite'],
        options: [
          {
            value: 'joined',
            title: 'Joined'
          },
          {
            value: 'invited',
            title: 'Invited'
          }
        ]
      }
    }
  },
  sort: {
    value: 'lastName',
    options: {
      lastName: {
        title: 'Name',
        value: -1
      },
      joined: {
        title: 'Joined',
        value: -1 
      }
    }
  },
  listParams: {
    name: 'People',
    action: 'loadUsers',
    params: {
      company: ''
    },
    requires: ['company']    
  },
  selected: {
    name: 'People'
  }
};


var invitesPage = {
  title: 'People',
  permissions: ['invite'],
  fab: {
    click: 'invite-create',
    permissions: ['invite']
  },  
  filterComponent: {
    cmp: 'vo-filter'
  }, 
  filtering: {
    search: {
      placeholder: 'Search Invites',
      value: ''
    },
    filters: {},
  },
  sort: {
    value: 'email',
    options: {
      email: {
        title: 'Email',
        value: -1
      },
      created: {
        title: 'Created',
        value: -1 
      }
    }
  },
  listParams: {
    name: 'Invites',
    action: 'loadInvites',
    params: {
      company: ''
    },
    requires: ['company']    
  },
  selected: false
};


var unitsPage =  {
  title: 'Units',
  permissions: ['unit'],
  fab: {
    click: 'unit-manage'
  },
  filterComponent: {
    cmp: 'vo-filter'
  },
  filtering: {
    search: {
      placeholder: 'Search Units',
      value: ''
    },
    filters: {
      property: {
        title: 'Properties',
        value: 'all',
        options: []
      },
      type: {
      title: 'Unit Types',
        value: 'all',
        options: []
      }
    }
  },
  sort: {
    value: 'title',
    options: {
      title: {
        title: 'Unit #',
        value: -1 
      }
    }
  },
  listParams: {
    name: 'Units',
    action: 'loadUnits',
    params: {
      company: ''
    },
    requires: ['company']
  },
  unitRoles: {
    listParams: {
      name: 'Unit Roles',
      action: 'loadUnitRoles',
      sort: '-created',
      requires: ['unit'],
      params: {
        unit: null
      }
    }
  },
  unitTickets: {
    listParams: {
      name: 'Unit Tickets',
      action: 'loadTickets',
      sort: '-created',
      requires: ['company'],
      params: {
        property: null
      }
    }
  },
  selected: false
};


var propertiesPage = {
  title: 'Company',
  permissions: ['property'],
  subtitle: 'Properties',
  filterComponent: {
    cmp: 'vo-filter-nav',
    params: {
      links: companyNav,
      navElement: companyNavOption
    }
  },     
  sort: {
    value: 'name',
    options: {
      name: {
        title: 'Name',
        value: -1 
      },
    }
  },
  unitTypes: {
    listParams: {
      name: 'Unit Types',
      action: 'loadUnitTypes',
      requires: ['property'],
      params: {
        company: null,
        property: null
      }
    }
  },
  listParams: {
    name: 'Properties',
    action: 'loadProperties',
    params: {
      company: ''
    },
    requires: ['company']    
  },
  selected: false
};

var roleTemplatesPage = {
  title: 'Company',
  subtitle: 'Role Templates',
  permissions: ['role'],
  fab: {
    click: 'role-template-manage'
  },
  filterComponent: {
    cmp: 'vo-filter-nav',
    params: {
      links: companyNav,
      navElement: companyNavOption
    }
  },     
  sort: {
    value: 'title',
    options: {
      title: {
        title: 'Name',
        value: -1 
      },
    }
  },
  listParams: {
    name: 'Role Templates',
    action: 'loadRoleTemplates',
    params: {
      company: ''
    },
    requires: ['company']    
  },
  selected: false
};


var ticketTagsPage = {
  title: 'Company',
  subtitle: 'Ticket Tags',
  permissions: ['ticketType'],
  fab: {
    click: 'ticket-tag-manage'
  },
  filterComponent: {
    cmp: 'vo-filter-nav',
    params: {
      links: companyNav,
      navElement: companyNavOption
    }
  }, 
  sort: {
    value: 'title',
    options: {
      title: {
        title: 'Name',
        value: -1 
      },
    }
  },
  listParams: {
    name: 'Ticket Tags',
    action: 'loadTicketTags',
    params: {
      company: ''
    },
    requires: ['company']    
  },
  selected: false
};

var activity = {
  listParams: {
    name: 'Recent Activity',
    action: 'loadNotifications',
    params: {

    }
  }
}

var settingsPage = {
  title: 'Settings',
}

var app = {
  accountNav        : accountNavDesktop,
  accountNavMobile  : accountNavMobile,
  navigation        : navigation,
  navigationMobile  : navigationMobile,
  activity          : activity,
  pages             : {
    tickets           : ticketsPage,
    joined            : peoplePage,
    invited           : invitesPage,
    units             : unitsPage,
    properties        : propertiesPage,
    roleTemplates     : roleTemplatesPage,
    ticketTags        : ticketTagsPage,
    settings          : settingsPage
  },
  ready             : false,  // Set to True when window.AppData.firstLoad completes
  versionLockout    : false   // Stores a globally accessible reference to whether or not the user should be locked out of the app for having an incompatible version
};

module.exports = app;


// WEBPACK FOOTER //
// ./src/app.js